import { getDataWithPromise, handleAjaxError} from "./BaseDataFns";

export const getSchoolAttendanceStats = (school_id, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/school/' + school_id + '/attendance_summary'  ;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
  .catch((jqXHR, textStatus, error) =>
  {
    handleAjaxError(jqXHR, textStatus, error);
  });

  return ;
};

export const getUsageSummary = (school_id, user_type_id, mode, in_school_hours, period, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/statistics/school/' + school_id + '/login?mode=' + mode + '&user_type_id=' + user_type_id
      + '&in_school_hours=' + in_school_hours + '&period=' + period;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const getResourceUsage = (school_id, group_id, resource_type, user_type, mode, in_school_hours, pupil_uid, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/statistics/school/' + school_id + '/resources?mode=' + mode + '&resType=' + resource_type
                                  + '&group_id=' + group_id + '&user_type=' + user_type + '&in_school_hours=' + in_school_hours + '&pupil_uid=' + pupil_uid;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const getResourceUsageByResource = (resource_id, in_school_hours, type, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/statistics/resource/' + resource_id + '?in_school_hours=' + in_school_hours + '&type=' +type;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

